import { render, staticRenderFns } from "./VRadioButton.vue?vue&type=template&id=198be4e7&"
import script from "./VRadioButton.vue?vue&type=script&lang=ts&"
export * from "./VRadioButton.vue?vue&type=script&lang=ts&"
import style0 from "./VRadioButton.vue?vue&type=style&index=0&id=198be4e7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports